import $ from 'jquery';
import flatpickr from 'flatpickr';

const lang = document.documentElement.lang;
const url = $("[data-js='event-list-url']").attr('value');
const loader = $('.loader');
const startDate = $("[data-js='event-list-start-date']").attr('value');
const endDate = $("[data-js='event-list-end-date']").attr('value');
function initializeDateTimepickers() {
  flatpickr('[data-js=datepicker_event]', {
    dateFormat: 'm/d/Y',
    minDate: startDate,
    maxDate: endDate,
    disableMobile: true
  });
}
function hideloadmore(show) {
  $('.js-load-more').hide();

  if (show) {
    $('.js-load-more').show();
  }
}

function checkLength(data) {
  return $(data).children().length === 12;
}

function setPaging(pageNumber) {
  $('#eventlistpageNumber').val(pageNumber);
}

function appendEvents(data) {
  $('#eventSection').append(data);
}

function updateEvents(data) {
  $('#eventSection').empty().html(data);
}


function getEventsSearch() {
  console.log($('#city').val());
  const eventSearch = {

    EmirateUId: $('#city').val(),
    SearchDate: $('#EventDate').val(),
    Skip: 0,
    Take: 12,
    Culture: lang
  };

  loader.addClass('is-active');


  $.ajax({
    type: 'GET',
    url,
    dataType: 'html',
    cache: false,
    data: eventSearch,
    traditional: true,
    error(data) {
      // eslint-disable-next-line no-undef
      alert(`Error: ${data}`);
    },

    success(data) {
      if (data) {
        updateEvents(data);
        setPaging(0);
        const show = checkLength(data);
        hideloadmore(show);
      } else {
        hideloadmore(false);
      }
    },

    complete() {
      loader.removeClass('is-active');
    }
  });
}

$('#city').on('change', () => {
  getEventsSearch();
});

$('#EventDate').on('change', () => {
  getEventsSearch();
});


function getEvents() {
  let pageNumber = $('#eventlistpageNumber').val();

  // eslint-disable-next-line radix
  pageNumber = parseInt(pageNumber) + 1;

  const eventSearch = {
    EmirateUId: $('#city').val(),
    SearchDate: $('#EventDate').val(),
    Skip: pageNumber,
    Take: 12,
    Culture: lang
  };

  loader.addClass('is-active');


  $.ajax({
    type: 'GET',
    url,
    dataType: 'html',
    cache: false,
    data: eventSearch,

    error(data) {
      // eslint-disable-next-line no-undef
      alert(`Error: ${data}`);
    },

    success(data) {
      if (data.trim() !== '') {
        appendEvents(data);
        setPaging(pageNumber);
        const show = checkLength(data);
        hideloadmore(show);
      } else {
        hideloadmore(false);
      }
    },

    complete() {
      loader.removeClass('is-active');
    }
  });
}

const eventList = () => {
  $(() => {
    initializeDateTimepickers();
    $('.js-load-more').on('click', () => {
      getEvents();
    });
  });
};

const getUrlParam = (name) => {
  const results = new RegExp(`[\?&]${name}=([^&#]*)`).exec(window.location.href);
  return results ? results[1] : 0;
};

const checkUrlParam = () => {
  const emirate = getUrlParam('emirate');
  if (emirate !== 0) {
    $('#city option').filter((index, node) => $(node).text().trim() === decodeURIComponent(emirate.replace(/\+/g, '%20'))).prop('selected', true);
    getEventsSearch();
  }
};


export default () => {
  eventList();
  checkUrlParam();
};

